import authReducers from './auth';

const rootReducer: any = {
  auth: authReducers,
};

export default rootReducer;
